import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: .2rem;
  width: 100%;
  border-radius: 0.2rem;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;

  .MuiIconButton-root {
    position: absolute; 
    top: .2rem; 
    right: .2rem;

    &:hover {
      background-color: transparent;
    }
  }

  .MuiCheckbox-root {
    &:hover {
      background-color: transparent;
    }
  }
`
export const Row = styled.div`
  display: flex;
  gap: 1.2rem;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  min-width: 16%;
`
